export type DesktopNavigationAction = 'reload' | 'force-reload' | 'navigate' | 'assign' | 'replace';

export type DesktopNavigationReason =
  | 'auth-session-expired'
  | 'auth-refresh-failed'
  | 'logout'
  | 'error-boundary-recovery'
  | 'client-update-available'
  | 'workspace-switch'
  | 'manual-retry'
  | 'incompatible-client'
  | 'local-data-recovery';

export interface DesktopNavigationIntent {
  readonly action: DesktopNavigationAction;
  readonly reason: DesktopNavigationReason;
  readonly targetUrl?: string;
}

export function recordDesktopNavigationIntent(intent: DesktopNavigationIntent): boolean {
  if (typeof window === 'undefined') return false;

  try {
    return window.electron?.diagnostics?.recordNavigationIntent(intent) ?? false;
  } catch {
    return false;
  }
}

export function reloadDocument(reason: DesktopNavigationReason): void {
  recordDesktopNavigationIntent({
    action: 'reload',
    reason,
    targetUrl: window.location.href,
  });

  window.location.reload();
}

export function replaceDocument(targetUrl: string, reason: DesktopNavigationReason): void {
  recordDesktopNavigationIntent({ action: 'replace', reason, targetUrl });
  window.location.replace(targetUrl);
}

export function assignDocument(targetUrl: string, reason: DesktopNavigationReason): void {
  recordDesktopNavigationIntent({ action: 'assign', reason, targetUrl });
  window.location.assign(targetUrl);
}
